import { cn } from '@/platform/lib/utils';
import { Description, Field, Label, Switch } from '@headlessui/react';

const Toggle = ({
    label,
    description,
    error,
    checked = false,
    onChange,
    required = false,
    disabled = false,
    className,
    ...props
}) => (
    <Field disabled={disabled} className={cn('block', className)}>
        <div className='inline-flex items-center gap-2 data-disabled:opacity-50'>
            <Switch
                checked={checked}
                onChange={onChange}
                invalid={error ? true : undefined}
                className={cn(
                    'group focus-visible:outline-primary-600 relative inline-flex h-5 w-9 shrink-0 cursor-pointer items-center rounded-full transition focus-visible:outline-2 focus-visible:outline-offset-2 data-disabled:cursor-not-allowed',
                    error
                        ? checked
                            ? 'bg-red-600'
                            : 'bg-red-200'
                        : checked
                          ? 'bg-primary-600'
                          : 'bg-gray-200'
                )}
                {...props}
            >
                <span
                    className={cn(
                        'inline-block size-4 transform rounded-full bg-white shadow transition',
                        checked ? 'translate-x-4' : 'translate-x-0.5'
                    )}
                />
            </Switch>
            {label && (
                <Label className='cursor-pointer text-sm/6 font-medium text-gray-900 select-none data-disabled:cursor-not-allowed'>
                    {label}
                    {required && (
                        <span className='inline-block pl-1 text-red-800'>
                            *
                        </span>
                    )}
                </Label>
            )}
        </div>
        {description && (
            <Description className='mt-1 text-sm/6 text-gray-500'>
                {description}
            </Description>
        )}
        {error && (
            <Description className='mt-1 text-sm text-red-600'>
                {error}
            </Description>
        )}
    </Field>
);

export default Toggle;
